import React, {useEffect, useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import OTPInput from "otp-input-react";
import "./css/OTP.scss";
// Common components
import ModalWrapper from "../../../common/others/ModalWrapper";
// Utils
import icons from "../../../../utils/icons";
import NavbarContext from "../../../../utils/contexts/Navbar";
import axios from "../../../../utils/http";
import {getRouter} from "../../../../utils/helpers";
import API from "../../../../utils/api";
import {toast} from "react-toastify";
import {logIn} from "../../../../redux/actions/clientActions";
import {useDispatch} from "react-redux";

const OTPModal = () => {
    const {t} = useTranslation();
    const {modalsDisplayStatus, toggleModals, authValues, setMaxConnections} = useContext(NavbarContext);

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    let interval = null;
    useEffect(() => {
        interval = setInterval(() => {
            timer > 0 && setTimer((prevState) => prevState - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    function toggle() {
        toggleModals({...modalsDisplayStatus, otp: false});
    }

    function renderTimer() {
        const minutes = Math.floor(timer / 60);
        const minutesToShow = minutes < 10 ? "0" + minutes : minutes;
        const seconds = timer % 60;
        const secondsToShow = seconds < 10 ? "0" + seconds : seconds;
        return minutesToShow + ":" + secondsToShow;
    }

    const resendOTP = async () => {
        setLoading(true);
        try {
            const {data} = await axios.post(getRouter(API.auth.otp, {
                userType: authValues.userType
            }), {
                mobile: authValues.phoneNumber,
                country_code: authValues.dialCode.replace('+', '')
            });

            if (data.success) {
                toast(data.data?.code, {type: 'success'})
                setTimer(120);
            }
        } catch (e) {

        }
        setLoading(false);
    }

    const handleChangeOTP = async (value) => {
        setOtp(value);
        console.log(value);

        if (value.length !== 5)
            return;

        try {
            const {data} = await axios.post(API.auth.userLogin, {
                mobile: authValues.phoneNumber,
                otp: value,
                country_code: authValues.dialCode.replace('+', '')
            });

            if (data.success) {
                const {user, token} = data.data;
                localStorage.setItem('token', token);
                axios.setAuthorizationHeader(token);
                dispatch(logIn(user));
                toggleModals({...modalsDisplayStatus, otp: false});
                clearInterval(interval);
            }
        } catch (e) {
            if (e.response?.status === 400 && e.response?.data?.data) {
                const data = e.response?.data?.data;
                setMaxConnections(data);
                toggleModals({...modalsDisplayStatus, otp: false, maxConnection: true});
            }
        }
    }

    return (
        <ModalWrapper className={"otp-modal"} toggle={toggle}>
            {icons.user}
            <p className={"center modal-title"}>{t("Login / Signup")}</p>
            <p className={"modal-tip"}>{t("Confirm your phone number")}</p>
            <div>
                <p>{authValues.dialCode}{authValues.phoneNumber}</p>
                <button
                    onClick={() => toggleModals({...modalsDisplayStatus, otp: false, auth: true})}>{t("Edit")}</button>
            </div>
            <p>{t("Please enter the code sent via SMS in the field below.")}</p>
            <OTPInput
                value={otp}
                onChange={handleChangeOTP}
                autoFocus
                OTPLength={5}
                otpType="number"
                className={"otp-input"}
            />
            {timer !== 0 && <div className={"center"}>
                <p>{renderTimer()}</p>
                {icons.progressRing}
            </div>}
            <p className={"center"}>{t("Remaining time")}</p>
            {timer === 0 && <button type={"button"} className={"button primary"} onClick={resendOTP}>
                {t("Resend")}
            </button>}

        </ModalWrapper>
    );
};

export default OTPModal;
